import React from 'react';
import { Box, Text } from '@razorpay/blade/components';
import { CustomFieldsDisplayProps } from './types';
import { formatFieldValue, isEmptyFieldValue } from './utils';

/**
 * Row layout mirrors the settings-page SalaryComponentsEntrypoint widget
 * (30% right-aligned muted label | 70% value, thin row separators inside a
 * bordered container) so v1-widget sections share one design language.
 */
export const CustomFieldsDisplay = ({ definitions, values }: CustomFieldsDisplayProps) => {
  const visible = definitions.filter((def) => def.effectiveAccess !== 'HIDDEN');
  return (
    <Box
      display="flex"
      flexDirection="column"
      backgroundColor="surface.background.gray.intense"
      paddingY="spacing.3"
      borderColor="surface.border.gray.subtle"
      borderWidth="thin">
      {visible.map((def, index) => (
        <Box
          key={def.fieldKey ?? ''}
          display="flex"
          flexDirection="row"
          borderBottomColor="surface.border.gray.subtle"
          borderBottomWidth={index < visible.length - 1 ? 'thin' : undefined}>
          <Box width="30%" padding="spacing.4" textAlign="right">
            <Text color="surface.text.gray.muted">{def.label}</Text>
          </Box>
          <Box width="70%" padding="spacing.4">
            {/* Empty values render like the legacy tables: muted -NA-
                (Blade Text has no fontStyle prop, so no italics). */}
            <Text
              color={
                isEmptyFieldValue(values[def.fieldKey ?? ''])
                  ? 'surface.text.gray.muted'
                  : 'surface.text.gray.normal'
              }>
              {formatFieldValue(def, values[def.fieldKey ?? ''])}
            </Text>
          </Box>
        </Box>
      ))}
    </Box>
  );
};
